import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import linkedin from "../../images/icons/socials/linked-in_author.svg"
import mailIcon from "../../images/icons/socials/mail.svg"

const Box = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: #151515;
  padding: 16px;
  color: #fff;
  border-radius: 8px;
  @media (min-width: 768px) {
    padding: 20px;
    width: 100%;
  }
  @media (min-width: 1024px) {
    width: 728px;
  }
  @media (min-width: 1200px) {
    width: calc(100% - 330px - 70px);
  }
`

const StyledAvatarAndName = styled.div`
  display: flex;
  margin-bottom: 12px;
  @media (min-width: 768px) {
    margin-bottom: -8px;
  }
  & img {
    width: 64px;
    height: 64px;
    background-color: #f9d6c1;
    border-radius: 4px;
  }
  & div {
    margin-left: 20px;
    align-self: flex-end;
    @media (min-width: 768px) {
      align-self: flex-start;
      margin-left: 16px;
    }
    & p:first-child {
      font-size: 20px;
      line-height: 16px;
      letter-spacing: 0.3px;
      font-family: "Made Medium", sans-serif;
    }
    & p:last-child {
      margin-top: 8px;
      color: #808080;
      line-height: 1.2;
      letter-spacing: 0.3px;
      font-size: 16px;
    }
  }
`

const SocialsAndDesc = styled.div`
  & p {
    font-size: 16px;
    line-height: 1.5;
    letter-spacing: 0.3px;
    font-family: "Made Light", sans-serif;
    @media (min-width: 768px) {
      margin-left: calc(64px + 16px);
    }
  }
`

const Socials = styled.div`
  display: flex;
  margin-top: 16px;
  align-items: flex-end;
  & a {
    margin-right: 16px;
    & img {
      transition: all 0.15s ease;
    }
    &:hover {
      img {
        transform: scale(1.1);
      }
    }
  }
  &.desktop-socials {
    display: none;
  }
  @media (min-width: 768px) {
    display: none;
    &.desktop-socials {
      display: flex;
      position: absolute;
      top: 5px;
      right: 5px;
      align-self: flex-end;
    }
  }
`

const AboutAuthor = ({ author }) => {
  const {
    avatar,
    authorName,
    authorJob,
    authorDesc,
    linkedInProfile,
    mail,
  } = author[0]
  return (
    <Box>
      <Socials className="desktop-socials">
        <a href={linkedInProfile}>
          <img
            src={linkedin}
            alt="LinkedIn Profile"
            title={`${authorName} - LinkedIn Profile`}
            target="_blank"
            rel="noopener noreferrer"
          />
        </a>
        <a href={`mailto:${mail}`}>
          <img src={mailIcon} alt="E-mail" title={`E-mail to ${authorName}`} />
        </a>
      </Socials>
      <StyledAvatarAndName>
        <img src={avatar} alt={authorName} title={authorName} />
        <div>
          <p>{authorName}</p>
          <p>{authorJob} w Nis Media</p>
        </div>
      </StyledAvatarAndName>
      <SocialsAndDesc>
        <p>{authorDesc}</p>
        <Socials>
          <a href={linkedInProfile}>
            <img
              src={linkedin}
              alt="LinkedIn Profile"
              title={`${authorName} - LinkedIn Profile`}
            />
          </a>
          <a href={`mailto:${mail}`}>
            <img
              src={mailIcon}
              alt="E-mail"
              title={`E-mail to ${authorName}`}
            />
          </a>
        </Socials>
      </SocialsAndDesc>
    </Box>
  )
}

export default AboutAuthor

AboutAuthor.propTypes = {
  author: PropTypes.arrayOf(
    PropTypes.shape({
      authorName: PropTypes.string.isRequired,
      authorJob: PropTypes.string.isRequired,
      authorDesc: PropTypes.string.isRequired,
      linkedInProfile: PropTypes.string.isRequired,
      mail: PropTypes.string.isRequired,
      avatar: PropTypes.string.isRequired,
    })
  ).isRequired,
}
